import React from 'react';
import { useDrag } from 'react-dnd';

function DocumentHealthProfile() {
  const [{ isDragging }, drag] = useDrag({
    item: { type: 'header' },
    collect: monitor => ({
      isDragging: !!monitor.isDragging()
    })
  });

  return <div className="card mb-2">
    <div
      ref={drag}
      style={{
        cursor: 'move',
        opacity: isDragging ? 0.1 : 1
      }}
      className="card-body p-2 bg-white">
      Header
    </div>
  </div>
}

export default DocumentHealthProfile;